const styles = {
  iconWrapper: 'inline-flex py-1 pr-2',
  icon: 'w-6 h-6',
  userCircle:
    'flex justify-center items-center w-8 h-8 rounded-full bg-lilac text-white text-overline',
};

export default styles;
